import { IDummyProps } from './types';

export const localeDropdown = (props: IDummyProps) => {
	return props.type == 'search'
		? {
				select: {
					noResultsMsg: 'No options found',
					placeholder: 'Search...',
					create: 'Search new option',
				},
		  }
		: {};
};
